import { ConditionOperatorsEnum, Filter } from 'utils/filters';

export const filterOptions: Filter[] = [
  {
    field: 'last_access',
    label: 'LAST_ACCESS_SINGULAR_KEY',
    isSelect: true,
    availableOperators: [ConditionOperatorsEnum.IS],
    selectOptions: [
      { value: '0d', label: 'DYNAMIC_FILTER.NO_ACCESS_KEY' },
      {
        value: '30d',
        label: 'DYNAMIC_FILTER.GREATER_THAN_OR_EQUAL_TO_30_DAYS_KEY',
      },
      {
        value: '60d',
        label: 'DYNAMIC_FILTER.GREATER_THAN_OR_EQUAL_TO_60_DAYS_KEY',
      },
      {
        value: '90d',
        label: 'DYNAMIC_FILTER.GREATER_THAN_OR_EQUAL_TO_90_DAYS_KEY',
      },
      {
        value: '180d',
        label: 'DYNAMIC_FILTER.GREATER_THAN_OR_EQUAL_TO_180_DAYS_KEY',
      },
    ],
  },
  {
    field: 'created_at',
    label: 'CREATION_DATE_KEY',
    availableOperators: [ConditionOperatorsEnum.IS],
    isSelect: true,
    selectOptions: [
      {
        value: '30d',
        label: 'DYNAMIC_FILTER.GREATER_THAN_OR_EQUAL_TO_30_DAYS_KEY',
      },
      {
        value: '60d',
        label: 'DYNAMIC_FILTER.GREATER_THAN_OR_EQUAL_TO_60_DAYS_KEY',
      },
      {
        value: '90d',
        label: 'DYNAMIC_FILTER.GREATER_THAN_OR_EQUAL_TO_90_DAYS_KEY',
      },
      {
        value: '180d',
        label: 'DYNAMIC_FILTER.GREATER_THAN_OR_EQUAL_TO_180_DAYS_KEY',
      },
    ],
  },
  {
    field: 'client_name',
    label: 'DYNAMIC_FILTER.CLIENT_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'environment_name',
    label: 'DYNAMIC_FILTER.ENVIRONMENT_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'partner_name',
    label: 'DYNAMIC_FILTER.PARTNER_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'company_name',
    label: 'DYNAMIC_FILTER.COMPANY_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'email',
    label: 'DYNAMIC_FILTER.EMAIL_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'username',
    label: 'DYNAMIC_FILTER.AD_USERNAME_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'first_name',
    label: 'DYNAMIC_FILTER.FIRST_NAME_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'last_name',
    label: 'DYNAMIC_FILTER.LAST_NAME_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'active',
    label: 'DYNAMIC_FILTER.STATUS_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'salt_configured',
    label: 'DYNAMIC_FILTER.SALT_CONFIGURED_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'mfa_configured',
    label: 'DYNAMIC_FILTER.MFA_CONFIGURED_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'is_integration_user',
    label: 'IS_INTEGRATION_USER_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'YES_KEY' },
      { value: 'false', label: 'NO_KEY' },
    ],
  },
  {
    field: 'ldap_type',
    label: 'DYNAMIC_FILTER.LDAP_TYPE_KEY',
    multiple: true,
    isSelect: true,
    selectOptions: [
      { value: 'internal', label: 'DYNAMIC_FILTER.INTERNAL_KEY' },
      { value: 'external', label: 'DYNAMIC_FILTER.EXTERNAL_KEY' },
      { value: 'managed', label: 'DYNAMIC_FILTER.MANAGED_KEY' },
    ],
  },
  {
    field: 'user_uuid',
    label: 'DYNAMIC_FILTER.USER_UUID_KEY',
  },
  {
    field: 'partner_uuid',
    label: 'DYNAMIC_FILTER.PARTNER_UUID_KEY',
    defaultOperator: ConditionOperatorsEnum.IS,
  },
  {
    field: 'environment_uuid',
    label: 'DYNAMIC_FILTER.ENVIRONMENT_UUID_KEY',
    defaultOperator: ConditionOperatorsEnum.IS,
  },
  {
    field: 'company_uuid',
    label: 'DYNAMIC_FILTER.COMPANY_UUID_KEY',
    defaultOperator: ConditionOperatorsEnum.IS,
  },
  {
    field: 'client_uuid',
    label: 'DYNAMIC_FILTER.CLIENT_UUID_KEY',
    defaultOperator: ConditionOperatorsEnum.IS,
  },
];
